import React from "react";
import {type PEPieData} from "@components/chart/types";
import Chart from "react-apexcharts";


export interface ProgrammeExplorerPieChartProps {
  data: PEPieData[]
  showLegend?: boolean
  height?: number | string
  chartId?: string
  children?: React.ReactNode
}
const ProgrammeExplorerPieChart: React.FC<ProgrammeExplorerPieChartProps> = ({data, showLegend = true, height = 300, children, chartId = 'pe_pie'}) => {

  const labels = data.map((element: PEPieData) => element.name);
  const values = data.map((element: PEPieData) => element.data);
  const colors = data.map((element: PEPieData) => element.color);

  return (
    <>
      {
        data.length > 0 ?
          (<Chart
            type={'pie'}
            height={height}
            series={values}
            options={{
              chart: {
                id: chartId,
                height: typeof height === 'number' ? height : undefined,
                zoom: {
                  enabled: false
                },
                animations: {
                  enabled: false,
                  easing: 'linear',
                  dynamicAnimation: {
                    speed: 1000
                  }
                },
                toolbar: {
                  show: false
                },
              },
              colors: colors,
              plotOptions: {
                pie: {
                  dataLabels: {
                    offset: 20
                  }
                }
              },
              labels: labels,
              dataLabels: {
                enabled: false
              },
              stroke: {
                curve: 'smooth',
                colors: ['primary']
              },
              fill: {
                opacity: 1,
                type: ['solid'],
              },
              markers: {
                size: 0
              },
              grid: {
                show: false
              },
              legend: {
                show: showLegend,
                position: 'right',
                formatter: function(seriesName, opts) {
                  const val = opts.w.globals.series[opts.seriesIndex];
                  return `${seriesName}: ${val}%`;
                }
              },
              tooltip: {
                enabled: true,
                followCursor: true,
                fixed: {
                  enabled: false,
                  position: 'topRight',
                  offsetX: 0,
                  offsetY: 0
                },
                y: {
                  formatter: function(val) { return `${val}%`; }
                }
              }
            }}>
          </Chart>)
          : null
      }

      {children}
    </>
  )
}

export default ProgrammeExplorerPieChart